import styled from 'styled-components'
import { Text } from '@gympass/yoga'
import tokens from '@gympass/yoga-tokens'

export const FooterWrapper = styled.section`
  padding-top: 20px;
  padding-bottom: 20px;
  background-color: #ffffff;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    padding: 32px 12px;
  }

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    padding: 32px 0;
  }
`

export const FooterContent = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    flex-direction: row;
    justify-content: space-between;
  }
`

export const LogoWrapper = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 20px;

  img {
    margin-bottom: 8px;
  }

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    align-items: flex-start;
    margin: 0;
  }
`
export const TextTiny = styled(Text.Tiny)`
  font-family: Lato;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 18px;
  margin-top: 32px;
  margin-bottom: 12px;
  color: #9898a7;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    font-size: 12px;
    margin: 0;
    padding: 0;
  }
`
